
import { createReducer } from 'redux-act';
import update from 'immutability-helper';
import moment from 'moment';

import { save_report, submit_report, remove_report, set_reports, add_reports, set_partial_reports, clear_partial_reports, replace_client_id } from '../actions';

const DEFAULT_STATE = {
	loaded: [],
	editing: [],
	submitted: [],
};

export default createReducer({
	[set_reports]:
		(state, payload) => update(state, { loaded: { $set: payload } }),
	[add_reports]:
		(state, payload) => {
			const query = payload
				.reduce((acc, report) => {
					const existingReportIndex = state.loaded.findIndex(({ id }) => report.id === id);
					if (existingReportIndex !== -1) {

						if (moment(report.lastUpdateTime).isAfter(state.loaded[existingReportIndex].lastUpdateTime)
							|| !report.partial) {
							return {
								...acc,
								[existingReportIndex]: { $set: report },
							}
						}
						return acc;
					}

					if (!acc['$push']) {
						return {
							...acc,
							$push: [report]
						}
					}
					return {
						...acc,
						$push: [...acc['$push'], report]
					}
				}, {});
			return update(state, {
				loaded: query
			});
		},
	[save_report]:
		(state, payload) => {
			const existingReportIndex = state.editing.findIndex(report => report.id === payload.id);
			if (existingReportIndex !== -1) {
				return update(state, { editing: { [existingReportIndex]: { $set: payload } } });
			}
			return update(state, { editing: { $push: [payload] } });
		},
	[submit_report]:
		(state, payload) => {
			const submit_update = { submitted: Array.isArray(state.submitted) ? { $push: [payload] } : { $set: [payload] } }

			const existingReportIndex = state.editing.findIndex(report => report.id === payload.id);
			if (existingReportIndex !== -1) {
				return update(state, { ...submit_update, editing: { $splice: [[existingReportIndex, 1]] } });
			}
			return update(state, submit_update);
		},
	[remove_report]:
		(state, payload) =>
			update(state, {
				loaded: { $splice: state.loaded.filter(report => report.id === payload.id).map(report => [state.loaded.indexOf(report), 1]) },
				editing: { $splice: state.editing.filter(report => report.id === payload.id).map(report => [state.editing.indexOf(report), 1]) },
				submitted: { $splice: state.submitted.filter(report => report.id === payload.id).map(report => [state.submitted.indexOf(report), 1]) }
			}),
	[set_partial_reports]:
		(state, payload) =>
			update(state, { partial: { $set: true } }),
	[clear_partial_reports]:
		(state, payload) =>
			update(state, { partial: { $set: false } })
}, DEFAULT_STATE);
